import styled from 'styled-components'

export default styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`